<template>
    
</template>

<script>
    export default {
        name: "FiltersMixin",
        computed: {
            getDisabledFilters () {
                return this.myData.disabledFilters || [];
            },
            getFiltersDisplay () {
                return this.myData.showFilters;
            },
            getPrimaryFilter () {
                return this.myData.primaryFilterKey ? this.myData.primaryFilterKey : "";
            },
            getSecondaryFilter () {
                return this.myData.secondaryFilterKey;
            },
        },
        methods: {
            setFilterDisplay (eventData) {
                this.changeMyData({
                    showFilters: !eventData.value
                })
                this.setChangesAreSaved(false);
            },
            setPrimaryFilter (eventData, resetSecondaryFilter = true) {
                let newData = {
                    primaryFilterKey : eventData.value,
                };

                if (resetSecondaryFilter) {
                    newData.secondaryFilterKey = "";
                }
                this.changeMyData(newData);
                this.setChangesAreSaved(false);
            },
            setSecondaryFilter (eventData) {
                this.changeMyData({
                    secondaryFilterKey : eventData.value
                })
                this.setChangesAreSaved(false);
            },
            setBothFilters (filterValues) {
                let newData = {
                    primaryFilterKey : filterValues.primaryFilterKey,
                    secondaryFilterKey : filterValues.secondaryFilterKey,
                };
                this.changeMyData(newData);
                this.setChangesAreSaved(false);
            },
            disableFilter (filterKey) {
                let dataToChange = {};
                let disabledFilters = this.myData.disabledFilters;

                if (disabledFilters.indexOf(filterKey) === -1) {
                    disabledFilters.push(filterKey);
                }

                dataToChange.disabledFilters = disabledFilters;

                // if (filterKey === this.getPrimaryFilter()) {
                //     this.setPrimaryFilter("");
                // }
                this.changeMyData(dataToChange);
                this.setChangesAreSaved(false);
            },
            enableFilter (filterKey) {
                let disabledFilters = this.myData.disabledFilters;
                let disabledFilterIndex = disabledFilters.indexOf(filterKey);

                if (disabledFilterIndex > -1) {
                    disabledFilters.splice(disabledFilterIndex ,1);
                }

                this.changeMyData({disabledFilters});
                this.setChangesAreSaved(false);
            }
        }
    }
</script>

